export default function PageJsonLd() {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "@id": "https://business-training.by/enciklopediya-korporativnogo-obucheniya#collectionpage",
        "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya",
        "name": "Энциклопедия корпоративного обучения сотрудников",
        "description": "Полное руководство по корпоративному обучению сотрудников. Виды обучения персонала, тренинги, развитие руководителей, soft skills, командообразование, адаптация, корпоративная академия и оценка эффективности обучения.",
        "isPartOf": {
          "@type": "WebSite",
          "@id": "https://business-training.by/#website",
          "name": "Business Training",
          "url": "https://business-training.by/"
        },
        "mainEntity": {
          "@type": "ItemList",
          "name": "Материалы энциклопедии корпоративного обучения",
          "numberOfItems": 10,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Article",
                "name": "Что такое корпоративное обучение",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Article",
                "name": "Обучение персонала",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/obuchenie-personala"
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Article",
                "name": "Обучение отдела продаж",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh"
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Article",
                "name": "Тренинг для руководителей",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley"
              }
            },
            {
              "@type": "ListItem",
              "position": 5,
              "item": {
                "@type": "Article",
                "name": "Развитие Soft Skills",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills"
              }
            },
            {
              "@type": "ListItem",
              "position": 6,
              "item": {
                "@type": "Article",
                "name": "Командообразование",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie"
              }
            },
            {
              "@type": "ListItem",
              "position": 7,
              "item": {
                "@type": "Article",
                "name": "Адаптация сотрудников",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov"
              }
            },
            {
              "@type": "ListItem",
              "position": 8,
              "item": {
                "@type": "Article",
                "name": "Корпоративная академия",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya"
              }
            },
            {
              "@type": "ListItem",
              "position": 9,
              "item": {
                "@type": "Article",
                "name": "Оценка эффективности обучения",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya"
              }
            },
            {
              "@type": "ListItem",
              "position": 10,
              "item": {
                "@type": "Article",
                "name": "Разработка программ обучения",
                "url": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya"
              }
            }
          ]
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Главная",
            "item": { "@id": "https://business-training.by/", "name": "Главная" }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Энциклопедия корпоративного обучения",
            "item": { "@id": "https://business-training.by/enciklopediya-korporativnogo-obucheniya", "name": "Энциклопедия корпоративного обучения" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое корпоративное обучение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Корпоративное обучение — это системный процесс развития профессиональных знаний, навыков и компетенций сотрудников компании. Оно включает тренинги, семинары, наставничество, бизнес-игры и другие форматы, направленные на повышение эффективности работы персонала и достижение бизнес-целей организации."
            }
          },
          {
            "@type": "Question",
            "name": "Чем отличается обучение от тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение — это более широкое понятие, включающее любые формы передачи знаний: лекции, вебинары, курсы, самообразование. Тренинг — это практико-ориентированный формат, где 70-80% времени отводится на отработку навыков через упражнения, ролевые игры, кейсы и обратную связь. Тренинг направлен на формирование конкретных поведенческих навыков."
            }
          },
          {
            "@type": "Question",
            "name": "Что входит в систему корпоративного обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Система корпоративного обучения включает: диагностику потребностей, разработку программ, проведение обучения (тренинги, семинары, наставничество), практическую отработку навыков, внедрение в работу, сопровождение после обучения и оценку эффективности по модели Киркпатрика. Также в систему могут входить корпоративная академия, программы адаптации и развития карьеры."
            }
          },
          {
            "@type": "Question",
            "name": "Когда компании стоит создавать корпоративную академию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Корпоративную академию стоит создавать при штате от 100-150 сотрудников, когда компании требуется системное масштабируемое обучение. Основные признаки: высокая текучесть кадров, необходимость унификации стандартов работы, потребность в постоянном повышении квалификации, географическая распределенность подразделений, активный найм новых сотрудников."
            }
          },
          {
            "@type": "Question",
            "name": "Что эффективнее: онлайн или офлайн обучение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Оба формата эффективны при правильном подходе. Офлайн-формат (в Минске и с выездом) лучше для командообразования, переговоров, продаж — где важна живая коммуникация и энергетика группы. Онлайн-формат удобен для удаленных команд, теоретических блоков и сопровождения. Оптимальный вариант — blended learning: сочетание очных интенсивов с онлайн-сопровождением."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценить эффективность корпоративного обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Эффективность оценивается по модели Киркпатрика на 4 уровнях: 1) Реакция — удовлетворенность участников; 2) Обучение — усвоение знаний и навыков; 3) Поведение — применение навыков на рабочем месте; 4) Результаты — влияние на бизнес-показатели (рост продаж, снижение текучести, повышение производительности)."
            }
          },
          {
            "@type": "Question",
            "name": "Как выбрать программу корпоративного обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Выбор программы зависит от бизнес-задач: для роста продаж — обучение отдела продаж и переговорам; для слабых руководителей — тренинг для руководителей; для конфликтов в команде — soft skills и тимбилдинг; для новых сотрудников — программы адаптации. Рекомендуется начинать с диагностики текущих проблем и целей компании."
            }
          },
          {
            "@type": "Question",
            "name": "Какие сотрудники должны обучаться первыми?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "В первую очередь обучаются те категории сотрудников, которые напрямую влияют на ключевые бизнес-показатели: руководители (их ошибки стоят дороже всего), отдел продаж (приносит доход), сотрудники на испытательном сроке (адаптация критична для удержания). Затем — все остальные категории по мере приоритетности задач."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу обучения под специфику компании?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация программы — обязательный этап подготовки. Программа настраивается под отрасль, размер компании, уровень подготовки сотрудников, конкретные бизнес-задачи. Используются реальные кейсы компании, типичные рабочие ситуации, отраслевая специфика. Это повышает практическую применимость обучения на 40-60%."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько времени занимает внедрение системы обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Полный цикл внедрения системы обучения занимает от 2 до 6 месяцев: диагностика (1-2 недели), разработка программы (2-4 недели), проведение обучения (1 день — 2 недели), сопровождение (1-3 месяца), оценка результатов (через 1-3 месяца после обучения). Сроки зависят от масштаба и сложности задач."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}